// extracted by mini-css-extract-plugin
export default {"header":"BlockHeader_header__QcYBa","headerName":"BlockHeader_headerName__uFdpH","headerRightBlock":"BlockHeader_headerRightBlock__eYcgA"};